/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
//import playImage from './play_button.png';
import { usePlayerSetUrl } from './PlayerContext';

import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';

//import pl from './play_button.png';

const PlayerImage = ({ url, asset, image }) => {
	const setUrl = usePlayerSetUrl();
	return (
		<div
			sx={{
				cursor: 'pointer',
				position: 'relative'
			}}
			onClick={() => setUrl(url)}
		>
			<GatsbyImage
				sx={{ mb: 1, mr: 1 }}
				objectFit="scale-down"
				image={image ? image : getImage(asset)}
				alt={''}
			/>
			<div
				sx={{
					display: 'block',
					opacity: 1,
					position: 'absolute',
					top: '50%',
					left: '50%',
					width: '30%',
					height: 'auto',
					transform: 'translate(-50%,-50%)',
					transition: '.3s opacity ease-in'
				}}
			>
				<StaticImage src="./play_button.png" />
			</div>
		</div>
	);
};

export default PlayerImage